import BuildIcon from '@mui/icons-material/Build';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import UndoIcon from '@mui/icons-material/Undo';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SearchIcon from '@mui/icons-material/Search';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import ShowerIcon from '@mui/icons-material/Shower';
import SanitizerIcon from '@mui/icons-material/Sanitizer';

const serviceIcon = (type: string) => {
    switch (type) {
        case 'sheets': return <WarehouseIcon sx={{ color: "#940000" }} />;
        case 'chemAppService': return <WarehouseIcon sx={{ color: "#EAA221" }} />;
        case 'preseason': return <UndoIcon sx={{ color: "#00796b" }} />;
        case 'refrigeration': return <AcUnitIcon sx={{ color: "#0288d1" }} />;
        case 'salesOrders': return <ReceiptIcon sx={{ color: "#546e7a" }} />;
        case 'chemAppInspections': return <SearchIcon sx={{ color: "#5d4037" }} />;
        case 'inspections': return <SearchIcon sx={{ color: "#5d4037" }} />;
        case 'freshPack': return <PrecisionManufacturingIcon sx={{ color: "#388e3c" }} />;
        case 'chemAppAgreement': return <CloudSyncIcon sx={{ color: "#7b1fa2" }} />;
        case 'sprayBarAgreement': return <ShowerIcon sx={{ color: "#0097a7" }} />;
        case 'disinfectantAgreement': return <SanitizerIcon sx={{ color: "#689f38" }} />;
        case 'chemAppsInspections': return <SearchIcon sx={{ color: "#5d4037" }} />;
        default: return <BuildIcon color="primary" />;
    }
};

export default serviceIcon;